import { computed } from '@angular/core';
import { EntityStatus, utils } from '@core';
import { signalStore, withComputed } from '@ngrx/signals';

import { withCommonState } from './common-filters.store';


export const FiltersStore = signalStore(
  { providedIn: 'root' },
  withCommonState('devices/filters'),

  withComputed(store => ({
    appliedFilters: computed(() => {
      let filters = {
        location: store.building(),
        space: store.room() || store.floor(),
        status: [store.status()],
      } as Record<string, string | string[]>;

      if (store.status() !== EntityStatus.Archived) {
        filters = {
          ...filters,
          deviceMaker: store.deviceMaker(),
          deviceType: store.deviceType(),
          query: store.query(),
          status: [EntityStatus.Active, EntityStatus.Paused, EntityStatus.Deactivated],
        };
      }

      return utils.clearObject(filters) as Record<string, string | string[]>;
    }),
  })),
);
